import { useState } from "react";

function EmergencyPlugin() {
  const [open, setOpen] = useState(false);

  const hospitals = [
    { name: "Baghpat", phone: "+91 9520882969" },
    { name: "Hapur", phone: "+91 7065000999" },
    { name: "Lakhanpur", phone: "+91 7081570570" },
    { name: "Mandhana", phone: "+91 7310473105" },
    { name: "Mathura", phone: "+91 9520750520" },
    { name: "Noida", phone: "+91 9711789898" },
  ];

  return (
    <div
      className={`fixed right-0 top-1/2 -translate-y-1/2 bg-red-700 text-white shadow-lg z-[9999] rounded-l-2xl transition-all duration-500 overflow-hidden flex items-center ${
        open ? "w-64" : "w-6"
      } h-[220px]`}
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
    >
      {/* Vertical label (now on the far right when closed) */}
      <div
        className="z-10 font-bold tracking-widest flex-shrink-0 w-6 text-xs px-0.5"
        style={{ writingMode: "vertical-rl", textOrientation: "upright" }}
      >
        EMERGENCY
      </div>

      {/* Expanded Panel */}
      <div
        className={`ml-3 w-full relative px-3 transition-all duration-500 ${
          open ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-full"
        }`}
      >
        <div
          className={`space-y-4 transition-all duration-700 delay-200 ${
            open ? "opacity-100 translate-y-0" : "opacity-0 translate-y-2"
          }`}
        >
          {hospitals.map((h, i) => (
            <div
              key={i}
              className={`flex flex-row gap-2 transition-all duration-500 ${
                open ? "opacity-100 translate-x-0" : "opacity-0 translate-x-4"
              }`}
              style={{
                transitionDelay: open ? `${300 + i * 100}ms` : "0ms",
              }}
            >
              <span className="text-[12px] font-semibold uppercase">{h.name}:</span>
              <a
                href={`tel:${h.phone}`}
                className="text-white text-[12px] font-bold hover:underline"
              >
                {h.phone}
              </a>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default EmergencyPlugin;
